export default class RecruitmentTeamTransformation {
  static transformRecruitmentTeamMember(data) {
    const { name, description, image, linkedin } = data;
    return {
      name,
      description,
      image,
      linkedin,
    };
  }

  static transformRecruitmentSteps(data) {
    const { title, image } = data;
    return {
      title,
      image,
    };
  }

  static transformPros(data) {
    const { title, image } = data;
    return {
      title,
      image,
    };
  }

  static transformHomePageData(data = { recruitmentTeam: [], recruitmentSteps: [], pros: [] }) {
    return {
      recruitmentTeam: data.recruitmentTeam?.map((team) => this.transformRecruitmentTeamMember(team)),
      recruitmentSteps: data.recruitmentSteps?.map((step) => this.transformRecruitmentSteps(step)),
      pros: data.pros?.map((pros) => this.transformPros(pros)),
    };
  }
}
